import { useState } from "react";

export default function Form({ onAddItem }) {
  const [description, setDescription] = useState("");
  const [quantity, setQuantity] = useState(1);
  const [category, setCategory] = useState("Holiday");


  function handleSubmit(e) {
    e.preventDefault();
    if (!description) return;

    const newItem = {
      id: Date.now(),
      description: description,
      quantity: Number(quantity),
      packed: false,
      category
    };

    onAddItem(newItem);

    setDescription("");
    setQuantity(1);
  }

  return (
    <form className="add-form" onSubmit={handleSubmit}>
      <h3>What do you need to pack?</h3>

      <select 
        value={quantity}
        onChange={(e) => setQuantity(e.target.value)}>
        <option>1</option>
        <option>2</option>
        <option>3</option>
      </select>

      <select
        value={category}
        onChange={(e) => setCategory(e.target.value)}
        >
        <option value="Holiday">🏖 Holiday</option>
        <option value="Work">💼 Work</option>
        <option value="School">🎒 School</option>
      </select>

      
      <input 
        type="text" 
        placeholder="Item..."
        value={description}
        onChange={(e) => setDescription(e.target.value)}
      />

      <button type="submit">ADD</button>
    </form>
  );
}